/**
 * Generated runtime TestId mirror for frontend/src/pages/provisioning/ProvisioningHistory.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ProvisioningHistoryTestIds = {
  btnRefresh: "btn-refresh",
  colAction: "col-action",
  colCompletedAt: "col-completed-at",
  colCreatedAt: "col-created-at",
  colEntitlement: "col-entitlement",
  colIdentity: "col-identity",
  colRetries: "col-retries",
  colStatus: "col-status",
  colTargetSystem: "col-target-system",
  historyMinQHint: "history-min-q-hint",
  historySearchScopeHint: "history-search-scope-hint",
  provisioningHistoryPage: "provisioning-history-page",
  linkIdentityDetail: (task_identity_id: string) => `link-identity-detail-${task_identity_id}`,
  linkIdentityDetailPrefix: () => "link-identity-detail-" as TestIdPrefix
} as const;
